export default __webpack_public_path__ + "static/media/Sarthakp.78ca3a70.jpeg";